import { useSelector } from "react-redux";
import ResultsPrincipal from "./principal/ResultsPrincipal.js";
import ResultsTeacher from "./teacher/ResultsTeacher.js";
import ResultsStudent from "./student/ResultsStudent.js";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";
import ResultsParent from "./parent/ResultsParent.js";

function Results() {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_principal) {
      return <ResultsPrincipal />;
    }
    if (state.auth.user.is_teacher) {
      return <ResultsTeacher />;
    }
    if (state.auth.user.is_student) {
      return <ResultsStudent />;
    }
    if (state.auth.user.is_parent) {
      if (!state.auth.isLoadingStudent) {
        return <ResultsParent />;
      }
      return <Loader />;
    }
    return <PermissionDenied />;
  }
}

export default Results;
